import { Modal, Button } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';

export function ConfirmModal({
  show, onHide, onConfirm,
  title = 'Confirmar',
  message,
  confirmLabel = 'Confirmar',
  confirmVariant = 'danger',
  icon: Icon = FaExclamationTriangle,
  iconColor = 'text-danger',
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <Icon size={48} className={`${iconColor} mb-3`} />
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancelar</Button>
        <Button variant={confirmVariant} onClick={onConfirm}>{confirmLabel}</Button>
      </Modal.Footer>
    </Modal>
  );
}
